var _text, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "423.938px",
    height: "403.2px",
    viewBox: "0 0 423.938 403.2",
    enableBackground: "new 0 0 423.938 403.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -318.7808 236.6875)",
    display: "none",
    fontFamily: "'TimesNewRomanPS-BoldMT'",
    fontSize: 700
  }, "\u263A")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FEEC40",
    d: "M423.938,153.927c0,0.141,0,0.283,0,0.426c-21.817,15.768-43.796,31.471-65.419,47.461 c-21.698,16.047-43.934,31.19-65.203,47.674c16.729,51.186,33.384,102.439,50.025,153.713 c-42.571-30.084-84.835-61.738-127.204-92.141c-1.176-0.846-3.938-3.006-4.276-2.994c-0.238,0.008-2.972,2.201-4.062,2.994 c-31.611,22.994-62.834,45.879-94.28,68.41c-10.994,7.879-21.522,16.381-32.708,23.516 c16.639-51.275,33.293-102.531,50.025-153.711C88.688,218.543,45.67,187.714,3.635,157.133c-1.249-0.909-2.771-1.858-3.635-3.206 c53.947,0,107.89,0,161.834,0C178.602,102.632,195.075,51.056,212.074,0c15.491,47.87,31.907,96.813,47.248,144.519 c1.007,3.137,1.486,6.623,3.419,9.408C316.475,153.927,370.207,153.927,423.938,153.927z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellow);
export default __webpack_public_path__ + "static/media/star-yellow.669d5add41b3b9ecdcd612821dc27b55.svg";
export { ForwardRef as ReactComponent };